import { MediaItem } from '../../types';
import { calculateInsertionPosition, createMediaItem, sortMediaItemsByStartTime } from '../../utils/mediaItemUtils';

export interface AIGenerationParams {
  addAtCurrentTime: boolean;
  currentTime: number;
  showNotification: (notification: any) => void;
}

/**
 * Handle AI-generated image addition to timeline
 */
export const handleAIImageGenerated = (
  imageUrl: string,
  prompt: string,
  params: AIGenerationParams,
  setMediaItems: React.Dispatch<React.SetStateAction<MediaItem[]>>,
  setIsAIImageModalOpen: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const { addAtCurrentTime, currentTime, showNotification } = params;

  setMediaItems(prevItems => {
    const imageDuration = 5;
    const { start, end } = calculateInsertionPosition(
      prevItems,
      addAtCurrentTime,
      currentTime,
      imageDuration
    );

    const newMediaItem = createMediaItem(
        `AI Generated: ${prompt.substring(0, 30)}...`,
        imageUrl,
        'image',
        start,
        end,
        {
          idPrefix: 'ai-generated'
        }
      );

    // showNotification({ 
    //   type: 'success', 
    //   message: 'AI generated image added to timeline!', 
    //   title: 'Success' 
    // });

    return sortMediaItemsByStartTime([...prevItems, newMediaItem]);
  });

  setIsAIImageModalOpen(false);
};

/**
 * Handle AI-generated video addition to timeline
 */
export const handleAIVideoGenerated = (
  videoUrl: string,
  prompt: string,
  duration: number,
  params: AIGenerationParams,
  setMediaItems: React.Dispatch<React.SetStateAction<MediaItem[]>>,
  setIsAIImageModalOpen: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const { addAtCurrentTime, currentTime, showNotification } = params;

  setMediaItems(prevItems => {
    const { start, end } = calculateInsertionPosition(
      prevItems,
      addAtCurrentTime,
      currentTime,
      duration
    );

    const newMediaItem = createMediaItem(
        `AI Video: ${prompt.substring(0, 30)}...`,
        videoUrl,
        'video',
        start,
        end,
        {
          idPrefix: 'ai-video'
        }
      );

    // showNotification({ 
    //   type: 'success', 
    //   message: `AI generated video (${duration}s) added to timeline!`, 
    //   title: 'Success' 
    // });

    return sortMediaItemsByStartTime([...prevItems, newMediaItem]);
  });

  setIsAIImageModalOpen(false);
};